import { ForwardedRef, forwardRef, useImperativeHandle, useState } from 'react';
import { BsArrowUpCircle } from 'react-icons/bs';
import './BaseScrollTopButton.scss';

type BaseScrollTopButtonProps = {
    onClick: () => void;
    bottomOffset?: string;
    rightOffset?: string;
};

export type BaseScrollTopButtonRef = {
    show: () => void;
    hide: () => void;
};

const BaseScrollTopButton = forwardRef(
    (
        { onClick, bottomOffset = '5rem', rightOffset = '1.25rem' }: BaseScrollTopButtonProps,
        ref: ForwardedRef<BaseScrollTopButtonRef>
    ) => {
        const className = 'scroll-top-btn';
        const [isVisible, setVisible] = useState(false);

        useImperativeHandle(ref, () => ({
            show: () => {
                setVisible(true);
            },
            hide: () => {
                setVisible(false);
            },
        }));

        return (
            <div
                style={{ right: rightOffset, bottom: bottomOffset }}
                className={`${className}__wrapper${isVisible ? ' --visible' : ''}`}
                data-testid="base-scroll-top-btn"
            >
                <BsArrowUpCircle className={`${className}__link`} onClick={onClick} />
            </div>
        );
    }
);

BaseScrollTopButton.displayName = 'BaseScrollTopButton';

export default BaseScrollTopButton;
